import React, { useEffect, useState } from 'react';
import { api } from '@/api/client';
export default function Policy(){
  const [list,setList]=useState<any[]>([]);
  useEffect(()=>{ api.get('/Policies/GetPolicies').then(({data})=>setList(data?.Policies||[])); },[]);
  return (<div><h2>Policy</h2>{list.map((p)=>(<div key={p.id}>{p.title} — {new Date(p.lastModified).toLocaleString('it-IT')}</div>))}</div>);
}
